import React, { useMemo } from 'react';
import { AssetDetails, Category } from '../../../api';
import { useDispatch, useSelector } from 'react-redux';
import { getDetails } from '../selectors';
import * as finderActions from '../actions';
import { Thumbnail } from '../../../../general/components/Thumbnail/Thumbnail';
import { FileOutlinedWithExtension } from '../../../../general/components/FullscreenPreview/viewers/MediaUnknown';

export const Related = () => {
  const dispatch = useDispatch();
  const details = useSelector(getDetails).asset;

  const relatedCategories = useMemo(() => {
    const assetsByCategoryId: Record<Category['id'], AssetDetails[]> = {};
    details?.related.forEach((asset) => {
      const id = asset.category?.id ?? '';
      const row = assetsByCategoryId[id] ?? [];
      row.push(asset);
      assetsByCategoryId[id] = row;
    });
    const result = Object.entries(assetsByCategoryId)
      .sort((a, b) => a[0].localeCompare(b[0]))
      .map(([_categoryId, assets]) => ({
        category: assets[0].category,
        assets,
      }));
    return result;
  }, [details]);

  return (
    <div className="al-finder-related">
      {relatedCategories.map(({ category, assets }) => (
        <div key={category?.id} className="al-finder-related-category">
          <div className="al-finder-related-category__name" title={category?.name}>
            {category?.name ?? '(out of categories)'}
          </div>
          <div className="al-finder-related-assets">
            {assets.map((asset) => {
              const fallback = <FileOutlinedWithExtension filename={asset.name} />;

              return (
                <div
                  key={asset.id}
                  className="al-finder-related-asset"
                  onClick={() =>
                    dispatch(
                      finderActions.assetSelected({
                        ids: [asset.id],
                        firstId: asset.id,
                        lastId: asset.id,
                      }),
                    )
                  }
                >
                  <div className="al-finder-related-asset__image-slot">
                    {asset.thumbnail_url ? (
                      <Thumbnail
                        className="al-finder-related-asset__image"
                        alt={asset.name}
                        src={asset.thumbnail_url}
                        fallback={fallback}
                        retry={false}
                      />
                    ) : (
                      fallback
                    )}
                  </div>
                  <div className="al-finder-related-asset__name" title={asset.name}>
                    {asset.name}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
      {relatedCategories.length === 0 && '(no assets)'}
    </div>
  );
};
